import React from "react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";

function QuickOverview() {
  const [image1Ref, image1Visible] = useScrollAnimation();
  const [image2Ref, image2Visible] = useScrollAnimation();
  const [image3Ref, image3Visible] = useScrollAnimation();

  return (
    <div className="quickoverview-wrapper">
      <div className="quickoverview flex">
        <img
          ref={image1Ref}
          src="/assets/images/lines.svg"
          alt="Lines"
          className={`quickoverview-image ${image1Visible ? "animate-in" : ""}`}
        />
        <img
          ref={image2Ref}
          src="/assets/images/mtagray.png"
          alt="MTA Gray"
          className={`quickoverview-image ${image2Visible ? "animate-in" : ""}`}
        />
        <img
          ref={image3Ref}
          src="/assets/images/content.png"
          alt="Content"
          className={`quickoverview-image ${image3Visible ? "animate-in" : ""}`}
        />
      </div>
    </div>
  );
}

export default QuickOverview;
